import React from 'react';
import { Empty, Spinner, Table } from '@hum/ui-library';
import ConnectionRow from './ConnectionRow';
import { getCompanyConnectors, useApiQuery } from '@hum/api';

export const CompanyServiceConnections = ({
  companyId,
}: {
  companyId: string;
}) => {
  const { data: connectors, isLoading } = useApiQuery(getCompanyConnectors, {
    params: { companyId: companyId! },
  });

  if (!connectors || isLoading) return <Spinner />;

  if (connectors.length === 0 && !isLoading) {
    return <Empty message="There are no services connected yet." />;
  }

  return (
    <Table>
      <Table.Head
        className="bg-defaultBg"
        labels={['Service', 'Created', 'Status', 'Health', 'Last Pull', '', '']}
      />
      <Table.Body>
        {connectors.map((connector) => (
          <ConnectionRow connector={connector} key={connector.id} />
        ))}
      </Table.Body>
    </Table>
  );
};
